<template lang="pug">
  #main
    #cover.min-vh-100
      #cover-caption
        .container
          .row.text-white
            .col-xl-5.col-lg-6.col-md-8.col-sm-10.mx-auto.text-center.form.p-4
                .px-2(v-if="loginErr", style="color: red", v-bind:data="errorText") {{ errorText }}
                form.fustify-content-center
                  .form-group
                    label.sr-only Email
                    input(type="email" placeholder="Email" v-model="email").form-control
                  .form-group
                    label.sr-only Password
                    input(type="password" placeholder="Password" v-model="password").form-control
                  b-button(type-submit, @click="login").btn.btn-primary.btn-lg Einloggen
                  //- b-button(type-submit, @click="singin", style="margin-left:10px").btn.btn-primary.btn-lg Registrieren
                a(href="/", style="") Home
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { auth } from "firebase";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      buttonText: "",
      loginErr: false,
      errorText: ''
    };
  },
  methods: {
    login: function() {
      auth().signInWithEmailAndPassword(this.email, this.password)
      .then(()=>{
        console.log("Eingeloggt");
        this.$router.push('scanner')
      })
      .catch((e)=>{
        console.log("Logging fehler: " + JSON.stringify(e))
        this.errorText = 'Fehler: Benutzer existiert nicht, bitte registriren'
        this.loginErr = true
      })
    },
    singin: function() {
      auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(user => {
          console.log("User " + JSON.stringify(user) + " was created");
          this.$router.push('scanner')
        })
        .catch(e => {
          this.errorText = 'Benutzer existiert bereits, bitte einloggen'
          this.loginErr = true
          console.log(e);
        });
    }
  }
};
</script>

<style>
#cover {
  background: #222 url("https://unsplash.it/1920/1080/?random") center center
    no-repeat;
  background-size: cover;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  position: relative;
}

#cover-caption {
  width: 100%;
  position: relative;
  z-index: 1;
}

/* only used for background overlay not needed for centering */
form:before {
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: -1;
  border-radius: 10px;
}
</style>